import { React, useEffect, useState } from "react";
import DashCard from "../components/UI/DashCard";
import FlexContainer from "../components/UI/FlexContainer";
import { useGetNomenklatursQuery } from "../store/nomenklaturaApi";
import FavoriteLinkCard from "../components/UI/FavoriteLinkCard";
import { useGetPaymentQuery } from "../store/paymentApi";
import { useGetDogovorsQuery } from "../store/dogovorApi";
import { useGetPaymentCodeQuery } from "../store/paymentCodeApi";

function HomePage(props) {
  const { data: nomenklaturaFB } = useGetNomenklatursQuery(
    "?sort[0]=id:desc&populate[1]=dogovor",
    { refetchOnMountOrArgChange: true }
  );
  const { data: dogovorFB } = useGetDogovorsQuery("?sort[0]=id:asc");
  const { data: paymentFB } = useGetPaymentQuery(
    "?sort[0]=id:desc&populate[1]=payment_code",
    { refetchOnMountOrArgChange: true }
  );
  const { data: paymentCodeFB } = useGetPaymentCodeQuery("?sort[0]=id:asc");
  const [nomenklatura, setNomenklatura] = useState([]);
  const [dogovors, setDogovors] = useState([]);
  const [payments, setPayments] = useState([]);
  const [paymentCodes, setPaymentCodes] = useState([]);

  useEffect(() => {
    const setData = async () => {
      try {
        const nomenkl = await nomenklaturaFB.data;
        const dogovor = await dogovorFB.data;
        const payment = await paymentFB.data;
        const paymentCode = await paymentCodeFB.data;
        setNomenklatura(nomenkl);
        setDogovors(dogovor);
        setPayments(payment);
        setPaymentCodes(paymentCode);
      } catch (error) {}
    };
    setData();
  }, [nomenklaturaFB, paymentFB, dogovorFB, paymentCodeFB]);

  // Начало расчета по графику Аренды
  const grafikPoArende = dogovors.map((dogovor) => {
    const filteredGrafik = dogovor.attributes.schedule.filter((item) => {
      const paymentDate = new Date(item.paymentDate);
      return paymentDate <= new Date();
    });
    const sortedGrafik = filteredGrafik.sort((a, b) => {
      return new Date(a.paymentDate) - new Date(b.paymentDate);
    });
    return sortedGrafik;
  });
  const arrayOfSum = grafikPoArende.map((schedul) => {
    const schedulReduce = schedul.reduce(
      (sum, current) => sum + Number(current.amount),
      0
    );
    return schedulReduce;
  });
  const totalAmountArenda = arrayOfSum.reduce(
    (sum, current) => sum + current,
    0
  );
  // Конец расчета по графику Аренды

  // Начало расчета по графику Налога
  const grafikPoNalogam = dogovors.map((dogovor) => {
    const filteredGrafik = dogovor.attributes.scheduleNalog.filter((item) => {
      const paymentDate = new Date(item.paymentDate);
      return paymentDate <= new Date();
    });
    const sortedGrafik = filteredGrafik.sort((a, b) => {
      return new Date(a.paymentDate) - new Date(b.paymentDate);
    });
    return sortedGrafik;
  });
  const arrayOfSumNalog = grafikPoNalogam.map((schedul) => {
    const schedulReduce = schedul.reduce(
      (sum, current) => sum + Number(current.amount),
      0
    );
    return schedulReduce;
  });
  const totalAmountNalog = arrayOfSumNalog.reduce(
    (sum, current) => sum + current,
    0
  );
  // Конец расчета по графику Налога
  const busyNomenklaturs = nomenklatura.map((item) => {
    const filteredItem = item.attributes.dogovor.data.filter(
      (dogovor) => new Date(dogovor.attributes.dateDogovorTo) > new Date()
    );
    return filteredItem;
  });

  const countOfBusyNomenklaturs = busyNomenklaturs.reduce(
    (sum, current) => sum + (current.length > 0 ? 1 : 0),
    0
  );

  const paymentArenda = payments.filter(
    (item) =>
      item.attributes.payment_code.data[0].attributes.code ===
      paymentCodes[0].attributes.code
  );
  const totalAmountOfPaymentArenda = paymentArenda.reduce(
    (sum, current) => sum + current.attributes.amount,
    0
  );

  const paymentNalog = payments.filter(
    (item) =>
      item.attributes.payment_code.data[0].attributes.code ===
      paymentCodes[1].attributes.code
  );
  const totalAmountOfPaymentNalog = paymentNalog.reduce(
    (sum, current) => sum + current.attributes.amount,
    0
  );

  return (
    <>
      <FlexContainer
        width={"70%"}
        margin={"70px auto"}
        justifyContent={"space-between"}
      >
        <DashCard
          link="/otchetPoObjectam"
          linkText="Отчет"
          title="Номенклатура"
          totalCountText="Общее количество"
          totalCount={nomenklatura.length}
        >
          Количество свободных: {nomenklatura.length - countOfBusyNomenklaturs}
        </DashCard>

        <DashCard
          link="/osv"
          linkText="Отчет"
          title="Аренда"
          totalCountText="Начислено всего"
          totalCount={totalAmountArenda.toFixed(3)}
        >
          Оплачено: {totalAmountOfPaymentArenda.toFixed(3)}
        </DashCard>
        <DashCard
          link="/otchetPoNalogam"
          linkText="Отчет"
          title="Налог"
          totalCountText="Начислено всего"
          totalCount={totalAmountNalog.toFixed(3)}
        >
          Оплачено: {totalAmountOfPaymentNalog.toFixed(3)}
        </DashCard>
      </FlexContainer>
      <FlexContainer
        width={"70%"}
        margin={"50px auto"}
        justifyContent={"space-between"}
      >
        <FavoriteLinkCard
          title="Карта"
          linkText="Открыть"
          link="https://www.google.com/maps?q=42.80147734760399, 73.85192394135296"
        >
          Сервис представляет собой карту <br /> и спутниковые снимки
        </FavoriteLinkCard>
        <FavoriteLinkCard
          title="Сайт"
          linkText="Открыть"
          link="https://kara-balta.kg/"
        >
          Официальный сайт
        </FavoriteLinkCard>
        <FavoriteLinkCard
          title="Отчет по контрагенту"
          linkText="Открыть"
          link="/otchetPoContragentu"
          disableNewTab={true}
        >
          Информация <br /> по арендатору
        </FavoriteLinkCard>
      </FlexContainer>
    </>
  );
}

export default HomePage;
